<template>
  <div class="hhgames-vn-footer" :class="{ mobile: ismobile }">
    <img
      src="https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173978535583053629.png"
      class="logo"
      alt=""
    />
    <div>
      <p class="game-name">Cực Tốc Tam Quốc</p>
      <p class="link-box">
        <a class="link" target="_blank" :href="supportUrl">Hỗ Trợ</a>
        |
        <a class="link" target="_blank" href="https://honghaco.vn/dieu-khoan">Điều Khoản</a>
        |
        <a class="link" target="_blank" href="https://honghaco.vn/bao-mat">Bảo Mật</a>
      </p>

      <p class="text">
        Email: hotro@hhgame.vn
        <br />
        Thời gian:
        <span style="color: red">8:00 - 18:00 thứ 2 - thứ 6</span>
        (GMT+7)
        <br />
        Chơi quá 180 phút một ngày sẽ ảnh hưởng xấu đến sức khỏe
        <br />
        Quyết định phê duyệt NDKB số: QĐ số 33/QĐ-PTTH&TTĐT cấp ngày 18/2/2025
        <br />
        Người chịu trách nhiệm nội dung: Ông Hoàng Quý Dương
        <br />
        Tầng 4 - Tòa nhà Tây Hà - 19 Tố Hữu - Phường Trung Văn - Quận Nam Từ Liêm - Hà Nội
      </p>
    </div>
    <img
      src="https://cdnimages.awselbcombine.com/public_images/one_image/2025/02/173978582616009748.png"
      class="j18"
      alt=""
    />
  </div>
</template>

<script>
import LinkTermUrl from '../../mixins/LinkTermUrl'
import { mapGetters } from 'vuex'
import globalConfig from '../../utiles/globalConfig'
const mainHost = globalConfig.getMainHost()
export default {
  data() {
    return {
      ismobile: window.isPhone,
      copyrightTime: window.copyrightTime
    }
  },
  computed: {
    supportUrl() {
      return `//gabres.${mainHost}/web/support.html?gameId=${this.gameId}&appLanguage=${this.lang}&language=${this.lang}&serverId=${this.serverId}&roleId=${this.roleId}&roleName=${this.roleName}`
    },
    ...mapGetters(['gameId', 'lang', 'serverId', 'roleId', 'roleName'])
  },
  mixins: [LinkTermUrl]
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_dimen.scss';
.hhgames-vn-footer {
  background: black;
  padding: 40px 0 30px;
  text-align: center;
  position: relative;
  .game-name,
  .text,
  .link-box {
    color: white;
    font-size: 13px;
    line-height: 200%;
    margin: 0;
    max-width: 100%;
  }
  .link {
    color: white;
    text-decoration: none;
    padding: 0 14px;
    position: relative;
    &:hover {
      color: #ff9500;
      cursor: pointer;
    }
  }
  .logo {
    position: absolute;
    width: 100px;
    height: 100px;
    top: 34px;
    left: 15%;
  }
  .j18 {
    position: absolute;
    width: 202px;
    height: 103px;
    top: 34px;
    right: 15%;
  }
  &.mobile {
    .link,
    .text {
      font-size: 12px;
    }
    .logo,
    .j18 {
      position: initial;
      display: block;
      margin: auto;
    }
    .logo {
      margin-bottom: 10px;
    }
  }
}
</style>
